import { Modal, Spin } from "antd";
import Icons from "../icons";
const { confirm } = Modal;

export const ErrorModal = (message) => {
  Modal.destroyAll();
  Modal.error({
    title: "Oops...",
    content: message || "Something went wrong",
    icon: <Icons type="cross" />,
  });
};

export const LoadingModal = (title, message) => {
  Modal.destroyAll();
  Modal.confirm({
    title: title || "Oops...",
    content: message || "Something went wrong",
    icon: <Spin size="large" />,
    footer: null, // Removes all buttons
    closable: false, // Allows closing the modal manually
  });
};

export const SuccessModal = (message) => {
  Modal.destroyAll();
  Modal.success({
    title: "Good job!",
    content: message || "",
    icon: <Icons type="checkright" />,
  });
};
export const OnOkDeleteModal = (message) => {
  Modal.destroyAll();
  Modal.success({
    title: "Deleted!",
    content: "Your file has been deleted.",
    icon: <Icons type="checkright" />,
  });
};
export const CancelDeleteModal = (message) => {
  Modal.destroyAll();
  Modal.error({
    title: "Cancelled",
    content: "Your imaginary file is safe :)",
    icon: <Icons type="cross" />,
  });
};

export const DeleteCModal = (message, action) => {
  Modal.destroyAll();
  confirm({
    title: "Are you sure?",
    icon: <Icons type="warning" />,
    content: message || `You Won't be able to revert this!`,
    okText: "Yes, delete it",
    okType: "danger",
    cancelText: "No, cancel",
    onOk() {
      action();
    },
    onCancel() {
      CancelDeleteModal();
    },
  });
};
